import { defineMessages } from 'react-intl'

export default defineMessages({
  copyLink: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.copyLink',
    defaultMessage: 'Copy link',
  },
  copyLinkSuccess: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.copyLinkSuccess',
    defaultMessage: 'Link copied to clipboard',
  }
})
